import { Reveal, ChapterLabel } from "./Motion";
import { FOUNDER, EDITORIAL } from "../../data/content";

export const Ch7Founder = () => (
  <section id="chapter-7" className="bg-cream py-28 sm:py-40">
    <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
      <div className="max-w-3xl">
        <Reveal><ChapterLabel index="The Founder" /></Reveal>
        <Reveal delay={0.1}>
          <h2 className="serif-display mt-8 text-[2rem] sm:text-[2.7rem] lg:text-[3.3rem] font-normal text-charcoal leading-[1.1]">
            Meet the Founder.
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <div className="mt-12 sm:mt-16 overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] border border-line/50 shadow-[0_30px_64px_rgba(36,35,32,0.14)]">
          <img
            src={EDITORIAL.founderEnv}
            alt={`${FOUNDER.name}, ${FOUNDER.title}, seated by a sunlit window with her journal`}
            className="block w-full h-auto sm:aspect-[16/10] sm:object-cover"
            loading="lazy"
          />
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <p className="mt-6 text-sm italic text-taupe max-w-md">
          {FOUNDER.name} — {FOUNDER.title}, photographed at home.
        </p>
      </Reveal>

      <div className="mt-12 sm:mt-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <Reveal>
            <blockquote className="serif-display text-3xl sm:text-4xl italic font-light text-sage-deep leading-snug">
              &ldquo;{FOUNDER.quote}&rdquo;
            </blockquote>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:col-start-6">
          <Reveal>
            <p className="serif-display text-2xl sm:text-[1.75rem] font-light leading-[1.5] text-charcoal max-w-xl">
              {FOUNDER.intro}
            </p>
          </Reveal>
          <div className="mt-7 space-y-6 max-w-xl">
            {FOUNDER.paragraphs.map((p) => (
              <Reveal key={p.slice(0, 24)} delay={0.1}>
                <p className="text-lg font-normal sm:font-light leading-[1.9] text-ink/85">{p}</p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <div className="mt-8 space-y-1.5 max-w-xl">
              {FOUNDER.lines.map((line) => (
                <p key={line} className="serif-display text-xl sm:text-2xl italic font-light leading-snug text-sage-deep">
                  {line}
                </p>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.3}>
            <p className="mt-8 text-lg font-normal sm:font-light leading-[1.9] text-ink/85 max-w-xl">
              {FOUNDER.closing}
            </p>
          </Reveal>

          <Reveal delay={0.4}>
            <div className="mt-10">
              <p className="serif-display text-4xl text-sage-deep italic">Felicia</p>
              <p className="mt-3 font-medium text-charcoal">{FOUNDER.name}</p>
              <p className="text-sm text-ink/60">{FOUNDER.title}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
